var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content report-setting" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { lazy: true, type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.tabCopyMonthSettingIsShowed
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("PillReport.CopyMonthSetting"),
                      name: "copyMonthSetting"
                    }
                  },
                  [
                    _c("tab-copy-month-setting", {
                      attrs: { "is-show": _vm.copyMonthSettingIsShow }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.tabFinanceSettingIsShowed
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("PillReport.FinanceSetting"),
                      name: "financeSetting"
                    }
                  },
                  [
                    _c("tab-finance-setting", {
                      attrs: { "is-show": _vm.financeSettingIsShow }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.tabHrSettingIsShowed
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("PillReport.HrSetting"),
                      name: "hrSetting"
                    }
                  },
                  [
                    _c("tab-hr-setting", {
                      attrs: { "is-show": _vm.hrSettingIsShow }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }